"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteMerchantCategory = deleteMerchantCategory;
exports.getMerchantCategoryInfo = getMerchantCategoryInfo;
exports.getMerchantCategoryOptions = getMerchantCategoryOptions;
exports.getMerchantCategoryTree = getMerchantCategoryTree;
exports.saveMerchantCategory = saveMerchantCategory;
exports.updateMerchantCategory = updateMerchantCategory;
exports.updateMerchantCategoryStatus = updateMerchantCategoryStatus;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 获取商户分类树形列表
 * @param {Object} params - 查询参数
 * @param {string|null} params.status - 状态：null查询全部，true正常，false失效
 * @param {string} params.name - 分类名称（可选）
 */
function getMerchantCategoryTree(params) {
  return (0, _request.default)({
    url: '/admin/merchant/category/tree',
    method: 'GET',
    params: params
  });
}

/**
 * 获取商户商品分类下拉树，仅返回 id、name、children。
 */
function getMerchantCategoryOptions(params) {
  return (0, _request.default)({
    url: '/admin/merchant/category/options/tree',
    method: 'GET',
    params: params
  });
}

/**
 * 新增商户分类
 * @param {Object} data - 分类数据
 */
function saveMerchantCategory(data) {
  return (0, _request.default)({
    url: '/admin/merchant/category/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑商户分类
 * @param {Object} data - 分类数据
 */
function updateMerchantCategory(data) {
  return (0, _request.default)({
    url: '/admin/merchant/category/update',
    method: 'POST',
    data: data
  });
}

/**
 * 删除商户分类
 * @param {string|number} id - 分类ID
 */
function deleteMerchantCategory(id) {
  // return request.get(`/admin/merchant/category/delete`);
  return (0, _request.default)({
    url: "/admin/merchant/category/delete",
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 获取商户分类详情
 * @param {string|number} id - 分类ID
 */
function getMerchantCategoryInfo(id) {
  return (0, _request.default)({
    url: "/admin/merchant/category/info/".concat(id),
    method: 'GET'
  });
}

/**
 * 更新商户分类状态
 * @param {string|number} id - 分类ID
 * @param {boolean} status - 状态：true正常，false失效
 */
function updateMerchantCategoryStatus(id, status) {
  return (0, _request.default)({
    url: '/admin/merchant/category/updateStatus',
    method: 'GET',
    params: {
      id: id,
      status: status
    }
  });
}